import { enableProdMode, ViewEncapsulation, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Logger } from '@app/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
const { matchHeight } = require('./assets/js/matchHeight.js');
(window as any)['matchHeight'] = matchHeight;
JSON['makeStringify'] = function (obj: any) {
  const cache: any = [];
  const s = JSON.stringify(obj, (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (cache.indexOf(value) !== -1) {
        return;
      }
      cache.push(value);
    }
    return value;
  });
  return s;
};
Logger.init();
if (environment.production) {
  enableProdMode();
}
const bootstrap = () =>
  platformBrowserDynamic().bootstrapModule(AppModule, {
    // Angular 21 defaults to zoneless change detection; keep zone.js-based change detection as before.
    applicationProviders: [provideZoneChangeDetection()],
    defaultEncapsulation: ViewEncapsulation.None,
  });

if (environment.hmr) {
  if ((module as any)['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
  }
} else {
  bootstrap().catch((err) => {
    console.log(err); // just keeping this console.log for angular death error
  });
}
